<template>
  <div v-if="!item.hidden&&item.children" class="menu-wrapper">
    <el-submenu
      v-waves 
      :index="item.id.toString()"
      @mouseover.native="$emit('mouseover',item.id.toString())"
      @mouseleave.native="$emit('mouseleave',item.id.toString())">
      <template slot="title">
        <item 
          v-if="isCollapse"
          icon="template" 
          :iconId="item.iconId"
          :title="item.name"
          @click.native.stop.prevent=""/>
        <item 
          v-else
          icon="template" 
          :iconId="item.iconId"
          :title="item.name"/>
      </template>
      <template v-for="child in item.children" v-if="!child.hidden">
        <sidebar-item
          v-if="child.children&&child.children.length>0"
          @nodeClick="itemClick"
          @filterNodeOpen="filterNodeOpen"
          :is-nest="true"
          :item="child"
          :filter="filter"
          :key="child.path"
          :isCollapse="isCollapse"
          class="nest-menu" 
          @handleCreate="handleCreate"
          @handleStartWrokFlow="handleStartWrokFlow"
          @mouseover.native="$emit('mouseover',child.id.toString())"
          @mouseleave.native="$emit('mouseleave',child.id.toString())"/>
        <el-menu-item 
          v-else 
          :index="child.id.toString()" 
          :key="child.id" 
          @click.native="itemClick(child)" 
          v-show="filterNode(filter,child)">
          <item 
            :icon="iconMap[child.type]"  
            :iconId="child.iconId"
            :title="child.name" 
            :name="child.mutableAdd"
            :type="child.type"
            :workFlowInfo="child.workFlowInfo"
            :operationType="child.operationType"
            @handleCreate="handleCreate(child)"
            @handleStartWrokFlow="handleStartWrokFlow(child)"/>
        </el-menu-item>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import Item from './Item'

export default {
  name: 'SidebarItem',
  components: { Item },
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    },
    filter: '',
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      iconMap: {
        0: 'form',
        1: 'query',
        2: 'workflow',
        5: 'decision'
      },
      onlyOneChild: null,
      openedNode: []
    }
  },
  methods: {
    filterNodeOpen(id) {
      this.$emit('filterNodeOpen', id)
    },
    filterNode(filter, data) {
      if (!filter) return true
      if (data !== undefined && data.name.indexOf(filter) !== -1) {
        this.$emit('filterNodeOpen', data.owner === -1 ? data.id : data.owner)
      }
      return data && data.name.indexOf(filter) !== -1
    },
    handleStartWrokFlow(node) {
      this.$emit('handleStartWrokFlow', node)
    },
    handleCreate(node) {
      this.$emit('handleCreate', node)
    },
    itemClick(node) {
      // 1 看 2 填
      // if ((node.operationType & 1) === 1) {
      const nodeClone = JSON.parse(JSON.stringify(node))
      this.$emit('nodeClick', nodeClone)
      // } else {
      //   this.$message.error(this.$t('error.noRightForHistory'))
      // }
    }
  }
}
</script>
<style rel="stylesheet/scss"  lang="scss">
  .el-submenu__title:hover{
    opacity: 0.95;
    & i{
      opacity: 0.95;
      transition: 0.3s;
    }
  }
  .el-menu-item{
    position: relative;    
    i {
      color: inherit !important;
      font-size: 16px;
    }
    &:hover{
      opacity: 0.95;
    }
    &:hover .previewButton{
      display: block;
    }
    .previewButton{
      display: none;
      position:absolute;
      right:20px;    
      padding:5px 6px;
      top:50%;
      margin-top: -12px;
      .el-icon-view{
        width: 14px;
        font-size: 14px !important;
        color:#fff;
        margin:0;
      }
    }
  }
  
</style>